import { atom } from "recoil";
import { persistAtom } from "./persist";

export interface IUserSuggestionsForSearchState {
  suggestedFollowers: Array<{
    _id: string;
    username: string;
    avatar: string;
    reason?: string;
    steam: {
      steamid?: string;
      personaname?: string;
    };
  }>;
  lastUpdated: number;
}

export interface IUserSuggestionsForSearchCacheState {
  [cacheKey: string]: IUserSuggestionsForSearchState;
}

export const UserSuggestionsForSearchState =
  atom<IUserSuggestionsForSearchCacheState>({
    key: "UserSuggestionsForSearchState_v1",
    default: {},
    effects_UNSTABLE: [persistAtom],
  });
